// import type { RoleName } from "../types/role"

/** Client role ID - used for route guards and API access checks */
export const CLIENT_ROLE_ID = 6;

/** Super Admin — full settings + exclusive Activity Log */
export const SUPER_ADMIN_ROLE_ID = 19;

export const ROLE_NAMES: Record<string, string> = {
  "Super Admin": "Super Admin",
  "System Administrator": "System Administrator",
  "Company Administrator": "Company Administrator",
  "Lodge Manager": "Lodge Manager",
  "Booking Agent": "Booking Agent",
  "Group Leader": "Group Leader",
  Representative: "Representative",
  Client: "Client",
};

export const ROLE_DESCRIPTIONS: Record<string, string> = {
  "Super Admin":
    "Full administrative access including activity log audit",
  "System Administrator": "Full access to all system features and settings",
  "Company Administrator": "Manages company-specific settings and users",
  "Lodge Manager": "Manages lodge operations, availability, and bookings",
  "Booking Agent": "Creates and manages bookings for clients",
  "Group Leader": "Coordinates group trips and communicates with agents",
  Representative: "Represents the company to clients and handles inquiries",
  Client: "Books trips and manages personal information",
};
